export default {
    QUOTAS_CONSTANTES: 'Quotas Constantes',
    SOMA_DIGITOS: 'Soma Dos Dígitos'
}
